module.exports = __webpack_public_path__ + "img/sorry.4901981c.png";